export default __webpack_public_path__ + "static/media/Logistics-Management.75d17a08.jpg";